




















































































































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import SearchFields, {SearchFieldType} from "@/entity/SearchEntity";
import dates from "@/components/inputs/dates.vue";
import EnabledSwitch from "@/components/inputs/EnabledSwitch.vue";

class requestPayload{
  name:String="";
  operator:String="";
  value:String="";
  type:String="";
}

@Component({
  components:{
    EnabledSwitch,
    dates
  }
})

export default class SearchForm extends Vue {
  @Prop({required : true}) fields!:SearchFields[];
  @Prop({required : true}) data!:any[];
  @Prop({required : true}) action!:string;
  requestData : requestPayload[] = [];
  activeFields:SearchFields[]=[];
  passiveFields:SearchFields[]=[];
  cacheKey:string = window.location.pathname + "_SearchFields";
  @Watch('fields')
  onPropertyChanged(value: string, oldValue: string) {
    this.init();
    //console.log("prop changed",value);
  }
  created(){
    this.init()
  }
  init(){
    let searchFields : any = localStorage.getItem(this.cacheKey);
    if(searchFields){
      searchFields = JSON.parse(searchFields);
      this.activeFields = searchFields.activeFields;
      this.passiveFields = searchFields.passiveFields;
    }else{
      this.activeFields = this.fields.filter((item:SearchFields)=>item.active == true);
      this.passiveFields = this.fields.filter((item:SearchFields)=>item.active == false);
    }
  }
  saveCache(){
    let json = {
      activeFields:this.activeFields,
      passiveFields:this.passiveFields
    };
    localStorage.setItem(this.cacheKey,JSON.stringify(json));
  }
  doPassive(field:SearchFields, key:number){
    this.passiveFields.push(field);
    this.activeFields.splice(key,1);
    this.saveCache();
  }
  doActive(field:SearchFields, key:number){
    this.activeFields.push(field);
    this.passiveFields.splice(key,1);
    this.saveCache();
  }
  fillItems(field:SearchFields){
    //console.log(field.data);
    let json:any = {};
    json[field.data?.itemText]="Seçiniz";
    json[field.data?.itemValue]="";
    return [json].concat(field.data.items);
  }
  async save(){
    this.requestData = [];
    this.activeFields.forEach((field:SearchFields)=>{
      if(field.operator == "")
        field.operator = "=";
      switch (field.type) {
        case SearchFieldType.Text:
          this.setPayload(field.name,field.operator,field.value,SearchFieldType.Text);
          break;
        case SearchFieldType.Boolean:
          this.setPayload(field.name,field.operator,field.value,SearchFieldType.Boolean);
          break;
        case SearchFieldType.ReverseBoolean:
          //console.log("REVERSE ",field.value);
          if(!field.value)
            break;
          let v = "0";
          if(field.value == "0")
            v = "1";
          this.setPayload(field.name,field.operator,v,SearchFieldType.ReverseBoolean);
          break;
        case SearchFieldType.Number:
          this.setPayload(field.name,field.operator,field.value,SearchFieldType.Number);
          break;
        case SearchFieldType.Select:
          this.setPayload(field.name,field.operator,field.value,SearchFieldType.Number);
          break;
        case SearchFieldType.Date:
          this.setPayload(field.name,field.operator,field.value,SearchFieldType.Date);
          break;
        case SearchFieldType.NumberBetween:
          this.setPayload(field.name,">",field.value,SearchFieldType.Number);
          this.setPayload(field.name,"<",field.value2,SearchFieldType.Number);
          break;
        case SearchFieldType.DateBetween:
          this.setPayload(field.name,">",field.value,SearchFieldType.Date);
          this.setPayload(field.name,"<",field.value2,SearchFieldType.Date);
          break;
      }
      //}
    });
    //console.log("requestData",this.requestData);
    /*
    let response = await Vue.prototype.$http.request({
        method:"POST",
        responseType:"json",
        data:JSON.stringify(this.requestData),
        transformRequest:[function (data:any, headers:any) {
            return data;
        }],
        url:this.action
    });
     */
    //this.data = response.data;
    this.$emit("searched",this.requestData);
    alert("Liste yüklendi");
  }
  setPayload(name:String,operator:String,value:any | string,type:String){
    if(value == "" || value == undefined || value == null)
      return;
    if(operator != "="){
      //Eşittir değilse boşuna  > veya < yollamayacak ayni name için
      let duplicate = this.requestData.find((v:requestPayload)=>v.name == name && v.operator == "=");
      if(duplicate){
        return;
      }
    }
    let payload = new requestPayload();
    payload.name = name;
    payload.operator = operator;
    payload.value = value;
    payload.type = type;
    this.requestData.push(payload);
  }
  handleKeydown (e:any) {
    switch (e.keyCode) {
      case 13:
        this.save();
        break;
    }
  }
  mounted() {
    window.addEventListener('keyup', this.handleKeydown);
  }
  destroyed() {
    window.removeEventListener('keyup', this.handleKeydown);
  }

}
